var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakeout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m122.67-80 162.66-653.33-1.33-29.34q-1-21-14.23-35.83-13.22-14.83-33.66-14.83-20.44 0-34.61 13.8-14.17 13.8-14.17 34.2v74h-66.66v-74q0-47.78 33.44-81.23Q187.56-880 235.33-880h451.34q46 0 79.5 31.17 33.5 31.16 35.83 77.16L840-80H122.67Zm86.66-66.67h113l-23-366-90 366Zm180 0H770L735.33-768q-1.66-19.33-15.52-32.33t-33.14-13H340.33q4.67 12 7 23.83 2.34 11.83 3.34 24.83l38.66 618ZM520-253.33h60V-400q26-6 43-27.5t17-49.5v-163h-40v151h-30v-151h-40v151h-30v-151h-40v163q0 28 17 49.5t43 27.5v146.67ZM389.33-146.67H770 389.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeout);
export default __webpack_public_path__ + "static/media/takeout.4ce52d55043ddca2992c59c1e924943e.svg";
export { ForwardRef as ReactComponent };